// ==========================
// DONNÉES PAR DÉFAUT
// ==========================
export const defaultData = {
  mainTitle: "DÉFIS CLÉS & SOLUTIONS STRATÉGIQUES",
  mainSubtitle:
    "Aborder les points sensibles critiques de l'industrie avec des méthodologies éprouvées",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/regulatory.png",
      title: "Complexité Réglementaire",
      text: "Naviguer dans les réglementations et exigences environnementales en évolution à travers de multiples juridictions.",
    },
    {
      icon: "/assets/icons/price.png",
      title: "Volatilité des Prix",
      text: "Gérer les risques financiers liés aux fluctuations des prix des matières premières et à l'incertitude du marché.",
    },
    {
      icon: "/assets/icons/esg.png",
      title: "Conformité ESG",
      text: "Respecter les normes environnementales, sociales et de gouvernance tout en maintenant l'efficacité opérationnelle.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/strategy.png",
      title: "Planification Stratégique",
      text: "Feuilles de route réglementaires complètes et cadres de conformité adaptés à vos opérations.",
    },
    {
      icon: "/assets/icons/risk.png",
      title: "Gestion des Risques",
      text: "Stratégies de couverture avancées et instruments financiers pour atténuer la volatilité du marché.",
    },
    {
      icon: "/assets/icons/sustainability.png",
      title: "Conseil en Durabilité",
      text: "Stratégies d'intégration ESG qui améliorent la réputation tout en favorisant l'excellence opérationnelle.",
    },
  ],
};

// ==========================
// DONNÉES PÉTROLE & GAZ
// ==========================
export const oilAndGasData = {
  mainTitle: "NAVIGUER DANS LES PRESSIONS FINANCIÈRES DU PÉTROLE & GAZ AVEC DES SOLUTIONS PLUS INTELLIGENTES",
  mainSubtitle:
    "Chaque obstacle financier cache une opportunité. Nous vous aidons à la débloquer avec des solutions numériques basées sur les données.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/cost.png",
      title: "Pressions sur les Coûts",
      text: "Les opérations pétrolières et gazières font face à des dépenses croissantes de production, de main-d'œuvre et de maintenance qui impactent la rentabilité et ralentissent la planification à long terme.",
    },
    {
      icon: "/assets/icons/cash.png",
      title: "Volatilité de Trésorerie",
      text: "Les fluctuations du marché et les données fragmentées limitent les prévisions précises, créent de l'incertitude sur la liquidité et retardent la prise de décision stratégique.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Charge de Conformité",
      text: "Le resserrement des réglementations environnementales et financières augmente la charge de travail administrative, la pression documentaire et les coûts liés aux audits.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/optimization.png",
      title: "Optimisation des Coûts",
      text: "L'automatisation, les flux de travail numériques et la surveillance des actifs réduisent les frais généraux manuels et rationalisent les processus.",
    },
    {
      icon: "/assets/icons/insights.png",
      title: "Insights en Temps Réel",
      text: "Les analyses intégrées et les tableaux de bord unifiés offrent une visibilité instantanée sur les actifs et les finances.",
    },
    {
      icon: "/assets/icons/auto-compliance.png",
      title: "Conformité Automatisée",
      text: "Le suivi numérique, le reporting automatisé et la documentation prête pour l'audit réduisent les risques de conformité.",
    },
  ],
};

// ==========================
// DONNÉES ÉNERGIE & SERVICES PUBLICS
// ==========================
export const powerAndUtilitiesData = {
  mainTitle: "SOULAGER LA PRESSION D'INVESTISSEMENT AVEC DES SOLUTIONS FINANCIÈRES PLUS INTELLIGENTES",
  mainSubtitle:
    "Des solutions financières claires pour les défis réglementaires les plus importants du secteur.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/cost.png",
      title: "Volatilité des Coûts",
      text: "L'énergie décentralisée, les prix fluctuants des combustibles et les coûts croissants d'exploitation et de maintenance pèsent sur la stabilité financière.",
    },
    {
      icon: "/assets/icons/grid.png",
      title: "Modernisation du Réseau",
      text: "Les réseaux vieillissants nécessitent des investissements en capitaux lourds avec des périodes de retour sur investissement longues.",
    },
    {
      icon: "/assets/icons/regulatory.png",
      title: "Pression Réglementaire",
      text: "Les réformes tarifaires et les mandats de conformité se resserrent à l'échelle mondiale.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Stabilisation des Marges",
      text: "Nous optimisons les structures de coûts et construisons des modèles qui protègent la rentabilité dans des conditions de marché incertaines.",
    },
    {
      icon: "/assets/icons/capital.png",
      title: "Clarté du Capital",
      text: "Nous concevons des cadres d'investissement, prévoyons le ROI et améliorons l'allocation du capital pour renforcer la performance à long terme des actifs.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Préparation à la Conformité",
      text: "Nous rationalisons le reporting, assurons l'alignement réglementaire et préparons les services publics aux structures d'audit et de tarification en évolution.",
    },
  ],
};

// ==========================
// DONNÉES GESTION DES DÉCHETS
// ==========================
export const wasteManagementData = {
  mainTitle: "RÉSOUDRE LES DÉFIS ACTUELS DE LA GESTION DES DÉCHETS",
  mainSubtitle:
    "Stratégies ciblées qui abordent les défis opérationnels, financiers et réglementaires du secteur.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/cost.png",
      title: "Coûts Croissants",
      text: "Les dépenses de carburant, de main-d'œuvre et de traitement continuent d'augmenter dans tout le secteur.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Conformité Réglementaire",
      text: "Les lois environnementales et les normes de reporting deviennent plus exigeantes.",
    },
    {
      icon: "/assets/icons/volume.png",
      title: "Volumes de Déchets",
      text: "Les populations croissantes augmentent la génération de déchets et la pression sur le système.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Contrôle des Coûts",
      text: "Nous optimisons la budgétisation, les dépenses opérationnelles et les structures financières pour de meilleures marges.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Support à la Conformité",
      text: "Nous aidons les organisations à se conformer aux réglementations, aux audits et aux exigences de durabilité.",
    },
    {
      icon: "/assets/icons/capacity.png",
      title: "Planification des Capacités",
      text: "Nous construisons des prévisions basées sur les données qui guident les mises à niveau d'infrastructure et les décisions d'investissement.",
    },
  ],
};

// ==========================
// DONNÉES MINES & MINÉRAUX
// ==========================
export const miningAndMineralsData = {
  mainTitle: "LES DÉFIS DU MINES. NOS RÉPONSES STRATÉGIQUES.",
  mainSubtitle:
    "Aider les équipes minières à naviguer dans les demandes croissantes avec des solutions claires, actionnables et durables.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/price.png",
      title: "Volatilité du Marché",
      text: "Les sociétés minières font face à des cycles de matières premières instables qui perturbent les prévisions, la planification des investissements et la stabilité des marges.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Conformité ESG",
      text: "Des attentes réglementaires plus strictes exigent un meilleur reporting, un contrôle des déchets, une réduction du carbone et une responsabilité envers l'impact sur la communauté.",
    },
    {
      icon: "/assets/icons/operations.png",
      title: "Inefficacités Opérationnelles",
      text: "Les actifs vieillissants, les temps d'arrêt imprévisibles et la surveillance manuelle réduisent la production et augmentent les dépenses opérationnelles.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/risk.png",
      title: "Couverture des Prix",
      text: "Nous construisons des cadres structurés et des modèles de risque-coût qui stabilisent les revenus et protègent la rentabilité à long terme.",
    },
    {
      icon: "/assets/icons/sustainability.png",
      title: "Cadres Durables",
      text: "Nos feuilles de route ESG intègrent le suivi des émissions, l'approvisionnement responsable et les améliorations axées sur la conformité tout au long du cycle de vie de la mine.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Mines Numériques",
      text: "Nous déployons des analyses, de l'automatisation et des modèles de maintenance prédictive pour réduire les coûts et améliorer la sécurité des travailleurs.",
    },
  ],
};

// ==========================
// DONNÉES SANTÉ
// ==========================
export const healthcareData = {
  mainTitle: "DÉFIS DE LA SANTÉ & SOLUTIONS PRATIQUES",
  mainSubtitle:
    "Guider les organisations de santé à travers les coûts croissants, les lacunes numériques et la complexité réglementaire.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/cost.png",
      title: "Coûts Croissants",
      text: "Les dépenses opérationnelles croissantes, les pénuries de main-d'œuvre et les perturbations de la chaîne d'approvisionnement érodent les marges.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Retard Numérique",
      text: "Les systèmes obsolètes limitent l'efficacité et ralentissent la prise de décision clinique.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Pression de Conformité",
      text: "Les prestataires de santé sont confrontés à des cadres réglementaires et des exigences de reporting de plus en plus stricts.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Réforme des Coûts",
      text: "Les modèles financiers simplifient les dépenses, améliorent l'allocation des ressources et protègent le succès à long terme.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Intégration Numérique",
      text: "Mise en œuvre de DSE modernes, d'automatisation intelligente et d'outils de données qui améliorent la vitesse et la précision.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Alignement Réglementaire",
      text: "Construire des processus de conformité solides avec une visibilité totale et un risque d'audit réduit.",
    },
  ],
};

export const lifeScienceData = {
  mainTitle: "PRESSION DU SECTEUR & SOLUTIONS PRÊTES POUR LA SCIENCE",
  mainSubtitle:
    "Aborder les obstacles scientifiques, réglementaires et financiers qui façonnent demain.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/clock.png",
      title: "Délais Cliniques Lents",
      text: "Les protocoles complexes, les lacunes de recrutement et les coûts opérationnels croissants retardent souvent les jalons cliniques.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Complexité Réglementaire",
      text: "Les mises à jour fréquentes des directives et les exigences régionales variables rendent la planification des approbations difficile.",
    },
    {
      icon: "/assets/icons/market.png",
      title: "Pression d'Accès au Marché",
      text: "Le contrôle accru des payeurs rend le lancement de nouvelles thérapies à la fois coûteux et incertain.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/digital.png",
      title: "Accélération des Essais",
      text: "Nous redessinons les flux de travail, optimisons la stratégie des sites et intégrons des outils numériques pour raccourcir les délais.",
    },
    {
      icon: "/assets/icons/compliance.png",
      title: "Clarté de la Conformité",
      text: "Nous fournissons des feuilles de route réglementaires structurées qui simplifient les soumissions et réduisent les risques d'approbation.",
    },
    {
      icon: "/assets/icons/strategy.png",
      title: "Stratégie de Valeur",
      text: "Nous construisons des cadres de tarification et de remboursement qui améliorent l'acceptation et la viabilité à long terme du marché.",
    },
  ],
};
export const privateEquityData = {
  mainTitle: "PRESSIONS D'INVESTISSEMENT & SOLUTIONS MESURÉES",
  mainSubtitle:
    "Aborder les réalités du capital-investissement moderne avec des stratégies axées sur les insights et prêtes à l'exécution.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/margin.png",
      title: "Volatilité des Valorisations",
      text: "Les marchés fluctuants et la qualité irrégulière des bénéfices rendent la tarification des transactions de plus en plus complexe.",
    },
    {
      icon: "/assets/icons/utilization.png",
      title: "Création de Valeur Lente",
      text: "Les portefeuilles font souvent face à des lacunes opérationnelles, une visibilité limitée et une exécution incohérente durant les 12 à 18 premiers mois.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Incertitude de Sortie",
      text: "L'évolution des attentes des acheteurs et le contrôle réglementaire augmentent le risque de sorties sous-performantes.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Discipline sur les Prix",
      text: "Nous construisons des modèles de valorisation ancrés dans la prévision de scénarios, la sensibilité des flux de trésorerie et les références sectorielles spécifiques.",
    },
    {
      icon: "/assets/icons/workforce.png",
      title: "Plans de Valeur Rapides",
      text: "Nous développons des plans de transformation sur 100 jours, des correctifs de gouvernance et des accélérateurs numériques qui créent un impact mesurable rapidement.",
    },
    {
      icon: "/assets/icons/automation.png",
      title: "Optimisation des Sorties",
      text: "Nous validons les indicateurs de performance, réduisons les signaux d'alerte opérationnels et préparons les actifs pour une sortie plus fluide et de plus grande valeur.",
    },
  ],
};


export const professionalServiceData = {
  mainTitle: "DÉFIS PROFESSIONNELS & SOLUTIONS PRATIQUES",
  mainSubtitle:
    "Soutenir les cabinets alors qu'ils naviguent dans la pression tarifaire, les lacunes opérationnelles et les défis de maturité numérique.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/margin.png",
      title: "Pression sur les Marges",
      text: "La concurrence intense, les coûts de livraison croissants et les modèles de tarification incohérents continuent de réduire la rentabilité des cabinets.",
    },
    {
      icon: "/assets/icons/utilization.png",
      title: "Écarts d'Utilisation",
      text: "Une mauvaise prévision, des charges de travail inégales et des inadéquations de compétences réduisent les heures facturables et affaiblissent l'efficacité de la livraison.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Sous-performance Numérique",
      text: "Les outils hérités, les données fragmentées et l'automatisation limitée ralentissent la prise de décision et impactent les résultats des projets.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Résilience des Marges",
      text: "Créer des cadres de tarification, des modèles de coûts et des contrôles d'engagement qui protègent la rentabilité et améliorent la qualité des revenus.",
    },
    {
      icon: "/assets/icons/workforce.png",
      title: "Optimisation de la Main-d'Œuvre",
      text: "Mettre en œuvre la planification des capacités, le suivi de l'utilisation et l'alignement des talents pour maintenir la cohérence de la livraison et la productivité.",
    },
    {
      icon: "/assets/icons/automation.png",
      title: "Modernisation Numérique",
      text: "Déployer l'automatisation, les flux de travail intégrés et les tableaux de bord en temps réel qui améliorent la visibilité et accélèrent les opérations.",
    },
  ],
};

export const publicSectorData = {
  mainTitle: "PRESSIONS PUBLIQUES. RÉPONSES PLUS INTELLIGENTES.",
  mainSubtitle:
    "Aborder les contraintes budgétaires, les inefficacités opérationnelles et les lacunes de transformation numérique.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/budget.png",
      title: "Contraintes Budgétaires",
      text: "Des budgets en réduction et des demandes opérationnelles croissantes limitent la qualité du service et restreignent la planification à long terme.",
    },
    {
      icon: "/assets/icons/process.png",
      title: "Processus Lents",
      text: "Les flux de travail longs, les opérations papier et les départements isolés retardent la livraison des services.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Arriérés Numériques",
      text: "Les systèmes hérités et la faible adoption numérique entraînent des erreurs, des retards et une faible visibilité des données.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/financial.png",
      title: "Optimisation Financière",
      text: "Construire des modèles financiers plus clairs et améliorer les stratégies d'allocation pour une meilleure valeur publique.",
    },
    {
      icon: "/assets/icons/process.png",
      title: "Redéfinition des Processus",
      text: "Simplifier les opérations, améliorer la coordination inter-départementale et réduire les délais de traitement.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Intégration Numérique",
      text: "Moderniser l'infrastructure, déployer des outils d'e-gouvernance et permettre des analyses en temps réel pour des décisions plus rapides.",
    },
  ],
};

export const realEstateConstructionData = {
  mainTitle: "COMPLEXITÉ DE LA CONSTRUCTION, SIMPLIFIÉE",
  mainSubtitle: "Nous visons à aider les promoteurs et les entrepreneurs à gérer les coûts croissants.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/cost.png",
      title: "Dépassements de Coûts",
      text: "Les prix variables des matériaux, les modifications de commande et une faible visibilité des achats font dépasser les budgets des projets.",
    },
    {
      icon: "/assets/icons/delivery.png",
      title: "Retards de Livraison",
      text: "Une mauvaise coordination, l'incohérence des sous-traitants et les flux de travail fragmentés créent des ralentissements de projets.",
    },
    {
      icon: "/assets/icons/operations.png",
      title: "Fragmentation Opérationnelle",
      text: "De multiples parties prenantes, des équipes séparées et un reporting manuel entraînent des écarts de visibilité et un risque plus élevé.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/cost.png",
      title: "Discipline des Coûts",
      text: "Renforcer le suivi financier, le contrôle des achats et les modèles de prévision protège les marges.",
    },
    {
      icon: "/assets/icons/delivery.png",
      title: "Optimisation de la Livraison",
      text: "La mise en œuvre de la planification, les tableaux de bord de supervision et les flux de travail intégrés maintiennent la prévisibilité de la livraison.",
    },
    {
      icon: "/assets/icons/governance.png",
      title: "Gouvernance Intégrée",
      text: "Établir un reporting unifié, un alignement inter-équipes et des cadres de gouvernance offre une livraison plus fluide.",
    },
  ],
};

export const mediaEntertainmentData = {
  mainTitle: "DÉFIS DES MÉDIAS & SOLUTIONS PRATIQUES",
  mainSubtitle:
    "Aider les entreprises médias à naviguer dans les changements de plateformes et l'incertitude croissante de production.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/margin.png",
      title: "Surcharge de Contenu",
      text: "Les audiences sont dispersées sur plusieurs plateformes, ce qui rend le financement du contenu plus difficile.",
    },
    {
      icon: "/assets/icons/utilization.png",
      title: "Coûts de Production Croissants",
      text: "Les délais serrés, les coûts des talents et l'exécution imprévisible détruisent la rentabilité.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Fragmentation de la Monétisation",
      text: "Les revenus publicitaires, OTT et combinés fluctuent selon les plateformes et les régions.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Cartographie du ROI du Contenu",
      text: "Construire des modèles qui identifient les formats, genres et marchés à haute performance pour un investissement plus intelligent.",
    },
    {
      icon: "/assets/icons/workforce.png",
      title: "Planification Intelligente de la Production",
      text: "Mettre en œuvre des contrôles de coûts, un alignement des fournisseurs et une refonte des flux de travail pour protéger les marges.",
    },
    {
      icon: "/assets/icons/automation.png",
      title: "Intégration des Systèmes de Revenus",
      text: "Créer des architectures de monétisation flexibles avec un reporting plus clair et une discipline tarifaire.",
    },
  ],
};
export const technologyData = {
  mainTitle: "DÉFIS TECH & SOLUTIONS CLAIRES",
  mainSubtitle:
    "Soutenir les leaders technologiques à travers une concurrence intense et des coûts croissants.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/margin.png",
      title: "Surcharge de Fonctionnalités",
      text: "Les équipes construisent trop, trop vite, avec des priorités peu claires.",
    },
    {
      icon: "/assets/icons/utilization.png",
      title: "Tension à l'Échelle",
      text: "À mesure que les équipes grandissent, la livraison ralentit, les processus se cassent et l'épuisement augmente.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Coûts Numériques Croissants",
      text: "Les dépenses cloud, les outils et les ressources d'ingénierie étirent les marges.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Concentration Produit",
      text: "Des cadres décisionnels plus affûtés pour réduire le bruit et accélérer les sorties significatives.",
    },
    {
      icon: "/assets/icons/workforce.png",
      title: "Affinement Opérationnel",
      text: "Des flux de travail plus propres, de meilleures structures d'équipe et des rythmes de livraison plus intelligents.",
    },
    {
      icon: "/assets/icons/automation.png",
      title: "Visibilité des Coûts",
      text: "Des insights plus clairs sur les dépenses, une utilisation optimisée et des opérations d'ingénierie plus lean.",
    },
  ],
};
export const telecommunicationData = {
  mainTitle: "EXIGENCES DE CONNECTIVITÉ & SOLUTIONS PRATIQUES",
  mainSubtitle:
    "Soutenir les opérateurs télécoms alors qu'ils naviguent dans la pression réglementaire et les attentes des clients.",

  leftTitle: "Défis de l'Industrie",
  rightTitle: "Nos Solutions",

  challenges: [
    {
      icon: "/assets/icons/margin.png",
      title: "Coûts Élevés du Réseau",
      text: "Les réseaux 4G/5G, l'expansion de la fibre et la maintenance des actifs continuent de peser sur les marges opérationnelles.",
    },
    {
      icon: "/assets/icons/utilization.png",
      title: "Désabonnement Client",
      text: "Les guerres de prix et la qualité de service incohérente poussent les clients à changer rapidement d'opérateur.",
    },
    {
      icon: "/assets/icons/digital.png",
      title: "Pression Réglementaire",
      text: "Les opérateurs font face à des règles d'attribution de spectre en évolution, des exigences de conformité et des régulations de la concurrence.",
    },
  ],

  solutions: [
    {
      icon: "/assets/icons/margin.png",
      title: "Efficacité des Coûts",
      text: "Redéfinir les modèles d'investissement, les stratégies de fournisseurs et la planification des infrastructures pour contrôler le capex et l'opex.",
    },
    {
      icon: "/assets/icons/workforce.png",
      title: "Amélioration de l'Expérience",
      text: "Améliorer les parcours de service, les points de contact numériques et la fiabilité pour réduire le désabonnement.",
    },
    {
      icon: "/assets/icons/automation.png",
      title: "Alignement Réglementaire",
      text: "Construire des cadres qui assurent la transparence, la préparation à la conformité et des résultats d'audit plus fluides.",
    },
  ],
};